<template>
  <span>
    <div class="article" v-loading="loading" :style="{minHeight: loading ? '100px' : 'unset'}" >
      <template v-if="article !== null" >
        <h2 class="article-title" >{{ article.title }}</h2>
        <div v-html="article.content" class="blog-post ql-editor" ></div>
      </template>
    </div>
    <div v-if="!previews.length" class="no-content" >
      <em>Aucun article disponible</em>
    </div>
    <el-carousel
       v-else-if="previews.length > 1"
       :autoplay="false"
       type="card"
       height="300px"
       @change="changeArticle"
       >
      <el-carousel-item v-for="preview in previews" :key="preview.id" >      
        <el-card :body-style="{padding: '0px'}" >
          <img :src="preview.preview" >
          <div class="card-content" >
            <h3>{{ preview.title }}</h3>
          </div>
        </el-card>
      </el-carousel-item>
    </el-carousel>
  </span>
</template>

<style scoped>
.el-carousel__item:nth-child(2n) {    
}
.el-carousel__item:nth-child(2n+1) {
}
.article-title {
    text-align: center;
}
.el-card img {
    max-width: 100%;
    max-height: 200px;
}
.blog-post >>> img {
    max-width: 100%;
}
.el-card {
    text-align: center;
}
.no-content {
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    text-align: center;
    display: flex;
    align-items: center;
    justify-content: center;
}
</style>

<script>
import {api} from 'macarons'
import 'quill/dist/quill.core.css'

export default {
  data () {
    return {
      loading: true,
      article: null,
      previews: []
    }
  },
  mounted () {
    api.get('blog/previews').then(response => {
      for (const preview of response.data) {
        this.previews.push(preview)
      }
      if (!this.previews.length) {
        this.loading = false
      } else if (this.previews.length === 1) {
        this.changeArticle(0)
      }
    })
  },
  methods: {
    changeArticle (index) {
      this.loading = true
      api.get('blog/post/' + this.previews[index].id).then(response => {
        this.article = response.data
        this.loading = false
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// node_modules/macarons-blog/Carousel.vue